import React from 'react';
import './dataviz.scss';

function Methodology() {
  return (
    <div>
        <div className='content' style={{ paddingTop:'60px' }}>
            <div className='content__text methodology' style={{ backgroundColor:'#F2E9E2', borderBottom:'1px solid #9F4400'}}>
            <h4>Methodology</h4>

            <p>WHYNOT analyzed data on Olympic champions from the Chinese delegation at the Summer and Winter Olympic Games from 1984 to 2024. The dataset does not include information related to the Paralympic Games.</p>
            <p><span>Figure 1:</span> Based on publicly available data, this dataset excludes samples where the athlete's current occupation is "unknown" or those still “active”.</p>
            <p><span>Figure 2:</span> China's city classification follows the 2024 “<a href='https://www.sohu.com/a/786838856_260141' target='_blank'>New First-Tier City Charm Rankings（新一线城市魅力排行榜）</a>" published by China Business Network (“第一财经”), which includes 337 prefecture-level and higher cities in mainland China, and other county-level cities and below. Samples with an "unknown" hometown or current residence, as well as those born overseas, were also excluded.</p>
            <p>
              To quantify residential mobility, WHYNOT encoded the data as follows: <br/>
              "County-level city and below" = <b>0</b>, <br/>
              "Fifth-tier city" = <b>1</b>, with values increasing incrementally, <br/>
              "Hong Kong and overseas" = <b>7</b>
            </p>
            <p>The mobility score was calculated as the difference between the current residence type and the hometown city type. The average mobility score for each sport was derived by dividing the total mobility score by the number of retired Olympic champions in that sport.</p>
            <p><span>Figure 3:</span> The dataset excludes athletes who are still "active" and only includes sports in which both male and female athletes have won Olympic gold medals.</p>
            <p><span>Figure 4:</span> The dataset excludes all 22 Winter Olympic champions and athletes who are still "active," focusing solely on retired Summer Olympic champions.</p>

            </div>

            <div className='content__text methodology' style={{ textAlign:'center', padding:'8% 0', color:'#9F4400', fontWeight:'400'}}>
                <h4>Credits</h4>
                <div className='credits'>
                    <div>Data Editor</div><div>Paul Wang</div>
                    <div>Reporter</div><div>Rachel Chen</div>
                    <div>Photo Editor</div><div>Shell Long</div>
                    <div>Design & Development</div><div>Regina Li</div>

                </div>
            </div>
        </div>

    </div>
  )
}

export default Methodology